var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['down',_vm.state==1?'loading':'']},[_c('div',{staticClass:"bg",style:({width:_vm.percentwidth+'%'})}),_c('a',{on:{"click":_vm.handleDown}},[_vm._v(" "+_vm._s(_vm.text)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }